import { AbstractFormElement, ICustomFormElement } from "./Abstract";

import { Checkbox } from "./Checkbox";

class Radio extends Checkbox implements ICustomFormElement {
    protected mainEvent: string = "change";

    /**
     * @inheritDoc
     */
    initElements() {
        super.initElements();
        this.input.type = "radio";
        console.warn("X-RADIO is deprecated. Use X-RADIO-GROUP instead.");
        return this;
    }

    /**
     * add event listeners
     */
    attachEvents() {
        this.label.addEventListener("click", () => {
            if (!this.checked) {
                this.checked = !this.checked;
                if (this.checked) {
                    const sel = `x-radio[name="${this.getAttribute("name")}"]`;
                    const others = document.querySelectorAll(sel) as NodeListOf<Radio>;
                    Array.from(others)
                        .filter((r) => r !== this)
                        .forEach((r) => (r.checked = false));
                }
                this.validate();
            }
        });
        return AbstractFormElement.prototype.attachEvents.call(this);
    }
}

Radio.prototype.template = document.createElement("template");

Radio.prototype.template.innerHTML = /*html*/ `
<label class="std-fe radio-check">
    <span class="input"></span>
    <span class="icon radio-btn keep-svg"></span>
    <span class="icon radio-btn keep-svg active"></span>
    <span class="label"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-radio", Radio);

export { Radio };
